<template>
  <div class="wt-super-page">
    <layout-general>
      <layout-header slot="header"></layout-header>
      <div class="wt2-sg" slot="left">
        <div class="-left-bar-super">
          <div class="wt2-text-xl -title">Super</div>
          <div class="-subtitle">Enter your text in the preview area.</div>
        </div>
      </div>
      <main-stage slot="main">
        <super-stage :active="true" :primary="true"></super-stage>
        <credit-stage :active="true" :primary="false"></credit-stage>
      </main-stage>
      <super-apply-cancel slot="footer"></super-apply-cancel>
    </layout-general>
  </div>
</template>

<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';
import SuperStage from 'AssetEditor/functionality/Super/SuperStage.vue';
import SuperApplyCancel from 'AssetEditor/functionality/Super/SuperApplyCancel.vue';
import CreditStage from 'AssetEditor/functionality/Credit/CreditStage.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';

export default {
  components: {
    LayoutGeneral,
    LayoutHeader,
    SuperStage,
    SuperApplyCancel,
    CreditStage,
    MainStage,
  },
};
</script>
